import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function gsapVerticalStickyContent() {
    const blocks = document.querySelectorAll('.vertical-sticky-content');

    if (!blocks.length) return;

    ScrollTrigger.matchMedia({
        // Desktop only
        "(min-width: 992px)": function() {
            blocks.forEach(block => {
                const stickyWrapper = block.querySelector('.sticky-content-wrapper');
                const contentItems = block.querySelectorAll('.content-item');
                const imageItems = block.querySelectorAll('.image-item');

                if (!stickyWrapper || !contentItems.length || !imageItems.length) return;

                // Pin the sticky content
                ScrollTrigger.create({
                    trigger: block,
                    start: "top top+=120", // Adjust offset as needed (header height)
                    end: "bottom bottom",
                    pin: stickyWrapper,
                    pinSpacing: false, // Keep it in the column flow
                    invalidateOnRefresh: true,
                });

                // Active state logic
                const setActive = (index) => {
                    contentItems.forEach(el => el.classList.remove('active'));
                    if (contentItems[index]) contentItems[index].classList.add('active');
                };

                imageItems.forEach((img, i) => {
                    ScrollTrigger.create({
                        trigger: img,
                        start: "top center",
                        end: "bottom center",
                        onEnter: () => setActive(i),
                        onEnterBack: () => setActive(i),
                    });
                });
            });
        },
        
        // Mobile/Tablet cleanup if needed
        "(max-width: 991px)": function() {
            // Optional: Reset styles or logic for mobile
        }
    });
}
